/** 删除原因 */
export const DELETE_REASONS = ['违反法律', '垃圾广告', '低俗信息', '封建迷信', '不友善、不尊重医生社区用户及内容的行为'];

export const VALUE_TYPE = {
    MODULE: 'moduleId',
    ITEM: 'itemId',
};
